<div>
  <!-- RECALL RESULTS AND FAQ'S: this html page is being content projected to tab-detail -->
  <!-- spinner! -->
  <ox-loading *ngIf="loading === true"></ox-loading>

  <div *ngIf="loading === false">
    <!-- Recalls -->
    <!-- No Recalls Found (Bad VIN) -->
    <!-- we need to show this section instead of the Recalls Found section -->
    <div *ngIf="(recallResults.length === 0 && completeRecallResults.length === 0 && recallSearchCompleted) && (hideWarranties || (warrantyResults && warrantyResults.expired.length === 0 && warrantyResults.active.length === 0 && warrantySearchCompleted))"
      class="margin-bottom-large">

      <!-- Message for Invalid VIN -->
      <div class="gb-headline2" role="heading" aria-level="2" [hidden]="mmyFound"
        [translate]="'recallCenter_noRecalls_header_noMMY'">
      </div>

      <!-- VIN Text -->
      <ul>
        <li>
          <div class="gb-descriptive1" [translateParams]="{searchedVin: searchedVin}"
               [translate]="'recallCenter_vin_label'"></div>
        </li>
        <li>
          <div *ngIf="refreshDate" class="gb-body2" [translateParams]="{refreshDate: refreshDate}"
               [translate]="'recallCenter_lastUpdated_label'">
          </div>
        </li>
      </ul>

      <hr>
    </div>

    <!-- Recalls Found -->
    <div *ngIf="!mmyFound && !!searchedVin">
      <!-- Recalls Title -->
      <div class="gb-headline2 mb-3" role="heading" aria-level="2"[translate]="'recallCenter_recalls_header'"></div>
      <p ox-alert type="error" *ngIf="recallsError">
        <span aria-atomic="true" role="alert" [translate]="'recallCenter_recalls_error'"></span>
      </p>
      <!-- Recalls: No Results Found -->
      <div *ngIf="recallResults.length === 0 && completeRecallResults.length === 0 && recallSearchCompleted"
          class="margin-bottom-large">

        <!-- Recalls: No Results Found Alert -->
        <div class="cit2-alert alert-info d-flex flex-column mb-5 mt-3" role="alert">
          <div class="content">
            <div class="text">

                <!-- Recalls: No Results Found Header -->
                <div class="gb-body1 heavy">
                  <p [translate]="'recallCenter_noRecalls_header_badVin'"></p>
                </div>

                <!-- Recalls: No Results Found Link Learn More -->
                <div class="gb-body2">
                  <a class="#" (click)="navigateToSection()" (keyup.enter)="navigateToSection()">
                    <span class="gb-link-label" tabindex="0" [translate]="'recallCenter_recalls_learnMore'"></span>     
                  </a>
                </div>

            </div>
          </div>
        </div>
        <hr>

      </div>

      <!-- Results found -->
      <div *ngIf="(recallResults.length > 0 || completeRecallResults.length > 0) && recallSearchCompleted">
        <p class="gb-body1" [innerHTML]="'recallCenter_description' | translate"></p>

        <!--NHTSA recalls -->
        <div *ngIf="nhtsaRecallExists">
          <div class="mb-6">
            <div class="gb-headline3 mb-1" role="heading" aria-level="3"
                [translate]="'recallCenter_safetyRecalls_header'"></div>
            <div class="mb-3"
                oxTrackLink
                [trackLink]="'recalls:whatsThis'"
                [trackDelay]="'true'"
                [trackType]="'o'"
                [prop10]="'recalls:link:Safety and Non-Compliance Recalls: What\'s This?'"
                [trackFirstClickOnly]="'true'">

              <ox-tooltip>
                <span class="title">
                  <span [translate]="'recallCenter_safetyRecalls_tooltip_title'"></span>
                </span>
                <div class="content">
                  <span [translate]="'rtext_recallCenter_safetyRecalls_tooltip_content'"></span>
                </div>
              </ox-tooltip>
            </div>
          </div>
        </div>

        <!-- Recalls Enhancement - October 2022  -->
        <gb-tab-nav class="gb-tab-nav">
          <ul class="content-button-group pl-6">
            <li class="content-button default mb-0">
              <button data-tab-id="content1" [translate]="'recallCenter_vinStatus_incomplete'"></button> <!--Incomplete-->
            </li>
            <li class="content-button mb-0">
              <button data-tab-id="content2" [translate]="'recallCenter_vinStatus_complete'"></button> <!--Complete-->
            </li>
          </ul>
          <div data-content-id="content1" class="content-container px-0">
            <button class="back-button">
              <div class="back-button-label">Back</div>
            </button>
            <ul class="recall-list-active">
              <ng-container *ngIf="recallResults.length > 0; else noIncompleteResults">
                <webu-tab-detail-item *ngFor="let recall of recallResults" [data]="recall" [link]="true" (detailsClick)="trackSearch($event)">
                  <!-- Recall Modal Incomplete Tab - content projection -->
                  <div recalls>
                    <ng-container [ngTemplateOutlet]="recalls"  [ngTemplateOutletContext]="{recall: recall}"></ng-container>
                  </div>
                  <!-- End of Recall Modal Incomplete - content projection -->
                </webu-tab-detail-item>
              </ng-container>
              <ng-template #noIncompleteResults>
                <webu-tab-detail-item [data]="recall" [link]="false" [checkCompleteIncomplete]="'incomplete'" (detailsClick)="trackSearch($event)">
                  <div class="content">
                    <div class="gb-body1">
                      <p>{{'recallCenter_empty_incompleteList' | translate}}</p>
                    </div>
                  </div>
                </webu-tab-detail-item>
              </ng-template>

            </ul>
          </div>
          <div data-content-id="content2" class="content-container px-0">
            <button class="back-button">
              <div class="back-button-label">Back</div>
            </button>
            <ul class="recall-list-inactive">
              <ng-container *ngIf="completeRecallResults.length > 0; else noCompleteResults">
                <webu-tab-detail-item *ngFor="let recall of completeRecallResults" [data]="recall" [link]="true" (detailsClick)="trackSearch($event)">
                  <!-- Recall Modal Complete Tab - content projection -->
                  <div recalls>
                    <ng-container [ngTemplateOutlet]="recalls" [ngTemplateOutletContext]="{recall: recall, completed: completeRecallResults}"></ng-container>
                  </div>
                  <!-- End of Recall Modal Complete - content projection -->
                </webu-tab-detail-item>
              </ng-container>
              <ng-template #noCompleteResults>
                <webu-tab-detail-item [data]="recall" [link]="false" [checkCompleteIncomplete]="'complete'" (detailsClick)="trackSearch($event)">
                  <div class="content">
                    <div class="gb-body1">
                      <p>{{'recallCenter_empty_completeList' | translate}}</p>
                    </div>
                  </div>
                </webu-tab-detail-item>
              </ng-template>
            </ul>
          </div>
        </gb-tab-nav>
        <!-- End of Recalls Enhancement October 2022 -->
      </div>
      <div class="gb-headline3 mb-3 mt-6" role="heading" aria-level="2" [translate]="'recallCenter_whatNow_header'"></div>
      <p class="gb-body1" [innerHTML]="'recallCenter_whatNow_firstParagraph' | translate" ></p>
      <p class="gb-body1 mt-2"  id="warrantySection">
        <span>{{recallCenterWhatNowSecondParagraph}}</span>&nbsp;
      </p>
      <hr>
    </div>

    <!-- Warranties -->
    <div *ngIf="!mmyFound && !!searchedVin && !hideWarranties">
      <!-- Warranties Title and Description -->
      <div class="gb-headline2 mb-3"  role="heading" aria-level="2" [translate]="'recallCenter_warranty_header'"></div>
      <p class="gb-body1" [innerHTML]="'recallCenter_warranty_description1' | translate"></p>
      <p class="gb-body1" [innerHTML]="'recallCenter_warranty_description2' | translate"></p>
      <p class="gb-body1">
        <a *ngIf="!isPOSH && warrantyBrandCmsID" [href]="'https://'.concat(warrantyBrandCmsID | translate)" target="_blank">
          <span role="presentation" class="icon-ui-newwindow" [attr.aria-label]="'aoda_open_new_window_aria_label' | translate"></span>&nbsp;
          <span [translate]="'recallCenter_warranty_learnMore'"></span>
        </a>
      </p>
      <p class="gb-body1 heavy" [innerHTML]="'recallCenter_warranty_description3' | translate"></p>
      <!-- Warranties: No Results Found -->
      <p ox-alert type="error" *ngIf="warrantyError">
        <span aria-atomic="true" role="alert" [translate]="'warrantyTracker_error_unableToLoad'"></span>
      </p>
      <div *ngIf="warrantyResults && warrantyResults.expired.length === 0 && warrantyResults.active.length === 0 && warrantySearchCompleted && !warrantyError"
           class="margin-bottom-large">

        <!-- Warranties: No Results Found Alert -->
        <div class="cit2-alert alert-info d-flex flex-column mb-5 mt-3" role="alert">
          <div class="content">
            <div class="text">

              <!-- Warranties: No Results Found Header -->
              <div class="gb-body1 heavy">
                <p [translate]="'recallCenter_noWarranties_header_noMMY'"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="warrantyResults && (warrantyResults.expired.length > 0 || warrantyResults.active.length > 0) && warrantySearchCompleted && !warrantyError">
        <gb-tab-nav class="gb-tab-nav">
          <!-- Warranties: Button for Active and Expired -->
          <ul class="content-button-group pl-6">
            <li class="content-button default mb-0">
              <button data-tab-id="content3" [translate]="'recallCenter_warrantyStatus_active'"></button>
            </li>
            <li class="content-button mb-0">
              <button data-tab-id="content4" [translate]="'recallCenter_warrantyStatus_expired'"></button>
            </li>
          </ul>

          <div data-content-id="content3" class="content-container px-0">
            <button class="back-button">
              <div class="back-button-label">Back</div>
            </button>
            <ul class="recall-list-active">
              <ng-container *ngIf="warrantyResults.active.length > 0; else noActiveWarranties">
                <webu-tab-detail-item *ngFor="let warranty of warrantyResults.active" [data]="warranty" [link]="true" (detailsClick)="trackSearch($event)">
                  <!-- Warranty Modal Active Tab-->
                <div warranties>
                    <div class="modal-body-cit2">
                      <div class="modal-grey-container">
                        <div class="row">
                          <div class="col-12" >
                            <div class="gb-body2">
                              <p class="mb-0"[translate]="'warrantyCenter_modal_active_header'"></p>
                            </div>
                            <div class="gb-body3 gb-color-grey-mid-dark mb-6">
                              <p class="mb-1" [translate]="'warrantyCenter_expiration_header'"
                                  [translateParams]="{endDate:warranty.expirationDate, endMileage:warranty.endMileage}"></p>
                            </div>
                            <p class="mb-0" [translate]="'warrantyCenter_modal_expired_desc'"></p>
                          </div>
                        </div>
                      <ng-container *ngIf="warranty.specialCoverageData">
                      <hr *ngIf="warranty.specialCoverageData[0].subject">
                      <div class="row" *ngIf="warranty.specialCoverageData[0].description">
                        <div class="col-12">
                        <div class="gb-body2">
                          <p class="mb-0" [translate]="'warrantyCenter_modal_field_action_header'"></p>
                        </div>
                        <div class="gb-body3 gb-color-grey-mid-dark mb-6">
                          <p class="mb-0">{{gfas(warranty.specialCoverageData[0], 'description')}}</p>
                        </div>
                      </div>
                    </div>
                    <div class="row" *ngIf="warranty.specialCoverageData[0].safetyRisk">
                      <div class="col-12">
                        <div class="gb-body2">
                          <p class="mb-0" [translate]="'warrantyCenter_modal_safety_risk_header'"></p>
                        </div>
                        <div class="gb-body3 gb-color-grey-mid-dark mb-6">
                          <p class="mb-0">{{gfas(warranty.specialCoverageData[0], 'safetyRisk')}}</p>
                        </div>
                      </div>
                    </div>
                    <div class="row" *ngIf="warranty.specialCoverageData[0].remedy">
                      <div class="col-12">
                        <div class="gb-body2">
                          <p class="mb-0" [translate]="'warrantyCenter_modal_repairs_header'"></p>
                        </div>
                        <div class="gb-body3 gb-color-grey-mid-dark mb-6">
                          <p class="mb-0">{{gfas(warranty.specialCoverageData[0], 'remedy')}}</p>
                        </div>
                      </div>
                    </div>
                      <hr *ngIf="warranty.specialCoverageData[0].subject">
                      </ng-container>
                    </div>
                  </div>
                </div>
                  <!--End of warranty Modal active-->
                </webu-tab-detail-item>
              </ng-container>
              <ng-template #noActiveWarranties>
                <webu-tab-detail-item [data]="warranty" [link]="false" [checkCompleteIncomplete]="'Active'" (detailsClick)="trackSearch($event)">
                  <div class="content">
                    <div class="gb-body1">
                      <p>{{'recallCenter_empty_activeWarranties' | translate}}</p>
                    </div>
                  </div>
                </webu-tab-detail-item>
              </ng-template>
            </ul>
          </div>

          <div data-content-id="content4" class="content-container px-0">
            <button class="back-button">
              <div class="back-button-label">Back</div>
            </button>
            <ul class="recall-list-inactive">
              <ng-container *ngIf="warrantyResults.expired.length > 0; else noExpiredWarranties">
                <webu-tab-detail-item *ngFor="let warranty of warrantyResults.expired" [data]="warranty" [link]="true" (detailsClick)="trackSearch($event)">
                  <!-- Warranty Modal Expired Tab -->
                  <div warranties>
                    <div class="modal-body-cit2">
                      <div class="modal-grey-container">
                        <div class="row">
                          <div class="col-12">
                            <div class="gb-body2">
                              <p class="mb-0" [translate]="'warrantyCenter_modal_expired_header'"></p>
                            </div>
                            <div class="gb-body3 gb-color-grey-mid-dark">
                              <p class="mb-1" [translate]="'warrantyCenter_expiration_header'"
                                  [translateParams]="{endDate:warranty.expirationDate, endMileage:warranty.endMileage}"></p>
                            </div>
                              <p class="mb-0" [translate]="'warrantyCenter_modal_expired_desc'"></p>
                          </div>
                        </div>
                        <ng-container *ngIf="warranty.specialCoverageData">
                        <hr *ngIf="warranty.specialCoverageData[0].subject">
                        <div class="row" *ngIf="warranty.specialCoverageData[0].description">
                          <div class="col-12">
                            <div class="gb-body2">
                              <p class="mb-0" [translate]="'warrantyCenter_modal_field_action_header'"></p>
                            </div>
                            <div class="gb-body3 gb-color-grey-mid-dark mb-6">
                              <p class="mb-0">{{gfas(warranty.specialCoverageData[0], 'description')}}</p>
                            </div>
                          </div>
                        </div>
                        <div class="row" *ngIf="warranty.specialCoverageData[0].safetyRisk">
                          <div class="col-12">
                            <div class="gb-body2">
                              <p class="mb-0" [translate]="'warrantyCenter_modal_safety_risk_header'"></p>
                            </div>
                            <div class="gb-body3 gb-color-grey-mid-dark mb-6">
                              <p class="mb-0">{{gfas(warranty.specialCoverageData[0], 'safetyRisk')}}</p>
                            </div>
                          </div>
                        </div>
                        <div class="row" *ngIf="warranty.specialCoverageData[0].remedy">
                          <div class="col-12">
                            <div class="gb-body2">
                              <p class="mb-0" [translate]="'warrantyCenter_modal_repairs_header'"></p>
                            </div>
                            <div class="gb-body3 gb-color-grey-mid-dark mb-6">
                              <p class="mb-0">{{gfas(warranty.specialCoverageData[0], 'remedy')}}</p>
                            </div>
                          </div>
                        </div>
                        <hr *ngIf="warranty.specialCoverageData[0].subject">
                        </ng-container>
                      </div>
                    </div>
                  </div>
                  <!-- End of Warranty Modal Expired -->
                </webu-tab-detail-item>
              </ng-container>
              <ng-template #noExpiredWarranties>
                <webu-tab-detail-item [data]="warranty" [link]="false" [checkCompleteIncomplete]="'Expired'" (detailsClick)="trackSearch($event)">
                  <div class="content">
                    <div class="gb-body1">
                      <p>{{'recallCenter_empty_ExpiredWarranties' | translate}}</p>
                    </div>
                  </div>
                </webu-tab-detail-item>
              </ng-template>
            </ul>
          </div>
        </gb-tab-nav>
      </div>
        <hr>
    </div>

    <!-- FAQs Sections-->
    <div  *ngIf="recallSearchCompleted" id="faqSection" #faqSection>
      <!-- FAQs Header -->
      <div class="gb-headline2 mb-3" role="heading" aria-level="2" [translate]="'recallCenter_faqs_header'"></div>

      <!-- FAQs for No Results Found-->
      <div *ngIf="recallResults.length === 0 && completeRecallResults.length === 0 && recallSearchCompleted">
        <ox-expander-collapse-dynamic-group [collection]="noResultsFoundFaq"></ox-expander-collapse-dynamic-group>
      </div>

      <!-- FAQs for Results Found -->
      <div *ngIf="(recallResults.length > 0 || completeRecallResults.length > 0) && recallSearchCompleted">
        <span class="gb-body1" [translate]="'recallCenter_faqs_resultsFound'"></span>
        <ox-expander-collapse-dynamic-group [collection]="foundResultsFaq"></ox-expander-collapse-dynamic-group>
      </div>
      <hr>
    </div>

    <webu-recall-center-search *ngIf="vinAttributes.maxlength && landingFaq"
                               [landingFaq]="landingFaq"
                               [vinAttributes]="vinAttributes"
                               [isAnotherSearch]="isAnotherSearch"
                               [refreshDate]="refreshDate">
    </webu-recall-center-search>
  </div>
  <!-- CLOSE NOT LOADING -->
</div>

<ng-template #recalls let-recall="recall" let-completed="completed">
  <div class="modal-body-cit2">
    <div class="modal-grey-container">
      <div class="row">
        <div class="col-6 col-xs-12">
          <div class="gb-body2">
            <p class="mb-0" [translate]="'recallCenter_modal_gm_program_header'"></p>
          </div>
          <div class="gb-body3 gb-color-grey-mid-dark">
            <p class="mb-0">{{gfas(recall, 'gfaNumber')}}</p>
          </div>
        </div>
        <div class="col-6 col-xs-12">
          <div class="gb-body2">
            <p class="mb-0" [translate]="'recallCenter_modal_status_header'"></p>
          </div>
          <div *ngIf="recall?.vinStatusInfo">
            <div *ngIf="!vinStatusDetailCheck(recall?.vinStatusInfo?.vinStatusDetail)">
              <div [ngSwitch]="recall?.vinStatusInfo?.vinStatus" class="gb-body3 gb-color-grey-mid-dark">
                <p class="mb-0" *ngSwitchCase="'complete'"
                  [translate]="'recallCenter_vinStatus_complete'"></p>
                <p class="mb-0" *ngSwitchCase="'incomplete'"
                  [translate]="'recallCenter_vinStatus_incomplete'"></p>
                <p class="mb-0" *ngSwitchDefault> status unknown </p>
              </div>
            </div>
            <div *ngIf="vinStatusDetailCheck(recall?.vinStatusInfo?.vinStatusDetail)">
              <div class="gb-body3 gb-color-grey-mid-dark">
                <p class="mb-0"> {{vinDetailLang(recall?.vinStatusInfo?.vinStatusDescriptions)}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr *ngIf="recall.governmentAgencies[0]">

      <div class="row"
          *ngIf="recall.governmentAgencies[0]">
        <div class="col-6 col-xs-12">
          <div class="gb-body2">
            <p class="mb-0">{{recall.governmentAgencies[0].govtAgencyId}}</p>
          </div>
          <div class="gb-body3 gb-color-grey-mid-dark">
            <p class="mb-0">{{recall.governmentAgencies[0].govtAgencyNum}}</p>
          </div>
        </div>
        <div class="col-6 col-xs-12">
          <div class="gb-body2">
            <p class="mb-0" [translate]="'recallCenter_modal_date_issued_header'"></p>
          </div>
          <div class="gb-body3 gb-color-grey-mid-dark">
            <p class="mb-0">{{recall.governmentAgencies[0].notificationDate}}</p>
          </div>
        </div>
      </div>

      <hr *ngIf="recall?.gfaTexts[0].description || recall.gfaTexts[0].safetyRisk">

      <ng-containter [ngTemplateOutlet]="modalBody" [ngTemplateOutletContext]="{recall: recall}"></ng-containter>

      <ng-container *ngIf="completed?.length>0">
        <ng-container [ngTemplateOutlet]="complete"></ng-container>
        <ng-template #complete >
          <div class="col-12 col-md-6">
            <div class="gb-body2">
              <p class="mb-0" [translate]="'recallCenter_modal_completed_header'"></p>
            </div>
            <div class="gb-body3 gb-color-grey-mid-dark">
              <p class="mb-0">{{recall?.vinStatusInfo?.closingDate}}</p>
            </div>
          </div>
        </ng-template>
      </ng-container>

    </div>


  </div>
</ng-template>

<ng-template #modalBody let-recall="recall">
  <span *ngFor="let gfasText of getLang(recall.gfaTexts)">
    <div class="row" *ngIf="gfasText && (gfasText?.description || gfasText?.safetyRisk)">
      <div class="col-12" >
        <div [hidden]="!gfasText.description">
          <div class="gb-body2">
            <p class="mb-0" [translate]="'recallCenter_modal_desc_header'"></p>
          </div>
          <div class="gb-body3 gb-color-grey-mid-dark mb-6">
            <p class="mb-0" >{{gfas(gfasText, 'description')}}</p>
          </div>
        </div>
        <div [hidden]="!gfasText?.safetyRisk">
          <div class="gb-body2">
            <p class="mb-0" [translate]="'recallCenter_modal_safety_risk_header'"></p>
          </div>
          <div class="gb-body3 gb-color-grey-mid-dark">
            <p class="mb-0">{{gfas(gfasText, 'safetyRisk')}}</p>
          </div>
        </div>  
      </div>
    </div>

      <hr>

      <div class="row" *ngIf="gfasText && gfasText?.remedy">
        <div class="col-12" >
          <div class="gb-body2" >
            <p class="mb-0" [translate]="'recallCenter_modal_repair_header'"></p>
          </div>
          <div class="gb-body3 gb-color-grey-mid-dark mb-6"
              >
            <p class="mb-0" >{{gfas(gfasText, 'remedy')}}</p>
          </div>
        </div>
    </div>
  </span>
</ng-template>
